/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-08 15:30:36
 * @LastEditors: loong
 * @LastEditTime: 2022-09-08 16:50:32
 */
// 通用主体顶部组件
// const AppHeader_Nav = () =>import ("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () =>import ("../../layout/AppHeader_main");
// 通用底部组件
// 当前路由组件
const productSearch = () => import('../../views/productSearch/index.vue');
export default [{
  path: "/productSearch",
  name: "productSearch",
  components: {
    header: '',//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: productSearch
  },
  meta: {
    requireAuth: false // 需要验证登录状态
  },
  props: {
      header: {
         type:'1',//根据不同类型切入组件判断逻辑
      }
  },
}
]
